import { render, staticRenderFns } from "./GeneralServicesChart.vue?vue&type=template&id=551a099a"
import script from "./GeneralServicesChart.vue?vue&type=script&lang=js"
export * from "./GeneralServicesChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports